"use client";
import { FC } from "react";
import Image from "next/image";
import Link from "next/link";

const ICONS = [
	{
		icon: "/icons/facebook.svg",
		href: "https://www.facebook.com/this.is.how.we.play/",
	},
	{
		icon: "/icons/instagram.svg",
		href: "https://www.instagram.com/worldbridgetour/",
	},
];

type Props = {};

const Contacts: FC<Props> = () => {
	return (
		<>
			<div className='w-full max-tablet:grid max-tablet:grid-cols-2 max-tablet:gap-x-[10px] bg-footerBg px-[77px] max-desktop:px-[30px] max-tablet:px-[16px] pt-[185px] max-desktop:pt-[142px] max-tablet:pt-[95px] flex justify-between pb-[60px] max-desktop:pb-[31px] '>
				<div className='flex flex-col max-tablet:pl-[8px]'>
					<Link href={"/"} prefetch={false}>
						<Image
							src='/icons/logo.png'
							width={575}
							height={167}
							alt='Logo footer'
							className='w-[175px] max-desktop:w-[111px] max-desktop:h-[42px] ml-[-5px]'
						/>
					</Link>
					<p className='text-[23px] max-desktop:text-[16px] mt-[16px] max-desktop:mt-[11px] max-desktop:w-[150px] leading-[18px] tracking-[1px]'>
						The Ultimate Bridge Experience.
					</p>
					<div className='flex gap-[12px] mt-[60px] max-desktop:mt-[23px]'>
						{ICONS.map((el, index) => (
							<a
								key={index}
								href={el.href}
								target='_blank'
								rel='noopener noreferrer'
							>
								<Image
									width={38}
									height={38}
									alt='Social icons'
									src={el.icon}
									className='max-desktop:w-[19px] max-desktop:h-[19px]'
								/>
							</a>
						))}
					</div>
				</div>

				<div className='flex flex-col mt-[30px] font-[600] max-desktop:mt-[10px]'>
					<p className='text-[20px] max-desktop:text-[14px] text-white mb-[0px]'>
						CONTACT US
					</p>
					<p className='text-[23px] max-desktop:text-[14px] font-[500]  text-white mb-[18px]'>
						hi@wbtbridge.com
					</p>
					<Link
						href={"/privacy-policy"}
						prefetch={false}
						style={{ all: "unset" }}
					>
						<p className='text-[20px] max-desktop:text-[14px] text-white cursor-pointer hover:underline'>
							PRIVACY POLICY
						</p>
					</Link>
					<Link
						href={"/terms-of-use"}
						prefetch={false}
						style={{ all: "unset" }}
					>
						<p className='text-[20px] max-desktop:text-[14px] text-white mb-[18px] cursor-pointer hover:underline'>
							TERMS OF USE
						</p>
					</Link>
				</div>

				<div className='flex flex-col max-tablet:w-full mt-[30px] max-desktop:mt-[15px] max-tablet:mt-[24px] max-tablet:col-span-2'>
					<p className='text-[20px] max-desktop:text-[13px] text-white mb-[19px] font-[600] max-tablet:mb-[10px] ml-[8px]'>
						NEWSLETTER
					</p>
					<div className='w-[305px] max-w-[382px] max-tablet:w-full max-desktop:w-[180px] h-[45px] max-desktop:h-[27px] rounded-[15px] px-[19px] text-footerBg bg-white/80 text-[18px] max-desktop:text-[13px] mb-[8px] max-desktop:mb-[4px] flex items-center opacity-70 cursor-not-allowed'>
						Newsletter disabled
					</div>
					<button
						className='h-[45px] flex items-center justify-center max-desktop:h-[27px] w-[142px] max-desktop:w-[84px] rounded-[15px] bg-greenButton text-white opacity-60 cursor-not-allowed'
						disabled
					>
						<p className='text-[18px] max-desktop:text-[12px]'>Subscribe</p>
					</button>
				</div>
			</div>

			<div className='bg-footerBg'>
				<div className='h-[2px] w-[calc(100%-160px)] max-desktop:w-full mx-auto bg-grayBg opacity-50'></div>
				<p className='text-center text-white opacity-50 mt-[19px] font-[400] pb-[25px] max-tablet:text-[10px] max-tablet:pb-[14px] tracking-[1px] max-tablet:mt-[10px]'>
					Copyright © 2024 World Bridge Tour
				</p>
			</div>
		</>
	);
};

export default Contacts;
